<ng-container>
    <!-- search filter -->
    <div class="inside-container">
        <div fxFlex="30" fxLayout="row" fxLayoutGap="10px">
            <tsl-form-field fxFlex>
                <tsl-label i18n="@@0fbc0bbce830bd50141fac696299f15bed5563c8"
                    t="0fbc0bbce830bd50141fac696299f15bed5563c8">Category</tsl-label>
                <tsl-select shape="rectangle" fullWidth [(ngModel)]="selectedCategory" (selectionChange)="onFilter()">
                    <tsl-option value=""></tsl-option>
                    <tsl-option *ngFor="let category of categories" [value]="category">{{ category }}
                    </tsl-option>
                </tsl-select>
            </tsl-form-field>
            <div fxLayoutAlign="space-between center" fxLayoutGap="10px">
                <button tsl-button color="black" outline size="small" (click)="onClearFilter()"
                    i18n="@@99ee4faa69cd2ea8e3678c1f557c0ff1f05aae46"
                    t="99ee4faa69cd2ea8e3678c1f557c0ff1f05aae46">Clear</button>
            </div>
        </div>
    </div>

    <div class="right addbutton" *ngIf="hasWriteAccess">
        <button tsl-button size="small" color="blue" (click)="onAdd()" i18n="@@4b3972c3e9485218508a95f7a4ce7758e3f09ced"
            t="4b3972c3e9485218508a95f7a4ce7758e3f09ced">Upload</button>
    </div>

    <!-- grid start -->
    <table tsl-table tslSort [dataSource]="datasource" (tslSortChange)="onSortChange($event)">
        <!-- category Column -->
        <ng-container tslColumnDef="category">
            <th tsl-sort-header tsl-header-cell *tslHeaderCellDef i18n="@@f61c6867295f3b53d23557021f2f4e0aa1d0b8fc"
                t="f61c6867295f3b53d23557021f2f4e0aa1d0b8fc">Type</th>
            <td tsl-cell *tslCellDef="let row">{{getCategory(row.documentType.newValue)}}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container tslColumnDef="name">
            <th tsl-sort-header tsl-header-cell *tslHeaderCellDef i18n="@@cff1428d10d59d14e45edec3c735a27b5482db59"
                t="cff1428d10d59d14e45edec3c735a27b5482db59">Name</th>
            <td tsl-cell *tslCellDef="let row">
                <a class="link" (click)="onDownloadFile(row, '1')">{{row.fileName.newValue}}</a>
            </td>
        </ng-container>

        <!-- Start Column -->
        <ng-container tslColumnDef="start">
            <th tsl-sort-header tsl-header-cell *tslHeaderCellDef i18n="@@3e6acd589d8b82cafd8546409da0a36469d297a0"
                t="3e6acd589d8b82cafd8546409da0a36469d297a0">Start Date</th>
            <td tsl-cell *tslCellDef="let row">{{row.effectiveDate?.newValue|date}}</td>
        </ng-container>

        <!-- End Column -->
        <ng-container tslColumnDef="expiry">
            <th tsl-sort-header tsl-header-cell *tslHeaderCellDef i18n="@@41d055ec9cef3afb116c3118c2244ee66c895fbb"
                t="41d055ec9cef3afb116c3118c2244ee66c895fbb">Expiration Date</th>
            <td tsl-cell *tslCellDef="let row">
                <span *ngIf="isExpired(row)" i18n="@@ffde7468d7b5cad6990095ed68ddee3d67cd02f8"
                    t="ffde7468d7b5cad6990095ed68ddee3d67cd02f8">Expired</span>
                <span *ngIf="!isExpired(row)">{{row.expiryDate?.newValue|date}}</span>
            </td>
        </ng-container>

        <!-- Signature Column -->
        <ng-container tslColumnDef="signature">
            <th tsl-sort-header tsl-header-cell *tslHeaderCellDef i18n="@@2ab79e0ca9186d7588d974b34b0872432d12b32d"
                t="2ab79e0ca9186d7588d974b34b0872432d12b32d">Signature Date</th>
            <td tsl-cell *tslCellDef="let row">{{row.signedDate?.newValue|date}}</td>
        </ng-container>

        <!-- Action Column -->
        <ng-container tslColumnDef="action">
            <th tsl-header-cell *tslHeaderCellDef i18n="@@030b4423b92167200e39519599f9b863b4f7c62c"
                t="030b4423b92167200e39519599f9b863b4f7c62c">Actions</th>
            <td tsl-cell *tslCellDef="let element" class="actions icons" width="8%">
                <div
                    *ngIf="element.operation.newValue || (canChangeItem(element) && element.operation?.newValue !== 'Delete') || (canChangeItem(element) && element.operation?.newValue !== 'Delete'); else empty">
                    <div *ngIf='element.operation.newValue'>
                        <span i18n="@@a593da3ff471120f6ffc6b6f4f3e46075fb40014"
                            t="a593da3ff471120f6ffc6b6f4f3e46075fb40014">Pending for approval - </span>
                        {{ translateService.get(element.operation.newValue)}}
                    </div>
                    <button tsl-icon-button *ngIf="canChangeItem(element) && element.operation?.newValue !== 'Delete'"
                        (click)="openDialog(element)">
                        <tsl-icon status="primary">edit</tsl-icon>
                    </button>
                    <button tsl-icon-button *ngIf="canChangeItem(element) && element.operation?.newValue !== 'Delete'"
                        (click)="deleteItem(element)">
                        <tsl-icon status="error">delete</tsl-icon>
                    </button>
                </div>
            </td>
        </ng-container>

        <tr tsl-header-row *tslHeaderRowDef="displayedColumns"></tr>
        <tr tsl-row *tslRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <!-- grid pagination -->
    <tsl-pagination showFirstLastButtons [pageSizeOptions]="pageSizeOptions" [total]="total" [pageSize]="pageSize"
        [pageIndex]="pageIndex" [itemsPerPageLabel]="translateService.get('ItemsPerPage')"
        (pageChange)="onPageChange($event)">
    </tsl-pagination>
</ng-container>